export default __webpack_public_path__ + "images/models/d8ebd3ec3bd42f6ad1fe649319973d31.glb";